// extracted by mini-css-extract-plugin
export var bestValueBtn = "BestValueBadge_bestValueBtn__tm1dp";